import React from 'react';
import { CtaButton } from './CtaButton';
import { Check } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-16 md:pt-32 md:pb-24 px-4 bg-brand-purpleLight" data-id="element-94">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-95">
        <div className="flex flex-col gap-6 text-center md:text-left order-2 md:order-1" data-id="element-96">
          <div className="inline-flex bg-brand-yellowLight text-brand-darkGray px-4 py-2 rounded-full w-fit mx-auto md:mx-0 font-semibold text-sm border border-brand-yellow/30" data-id="element-97">
            Para las que tienen air fryer y nunca la encienden
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-brand-darkGray leading-tight" data-id="element-98">
            Tu air fryer lleva meses guardada.{' '}
            <span className="italic text-brand-purple" data-id="element-99">Hoy eso cambia.</span>
          </h1>

          <p className="text-lg md:text-xl text-brand-mediumGray font-medium leading-relaxed" data-id="element-100">
            Más de 30 recetas listas en menos de 20 minutos. Sin saber cocinar.
            Sin ingredientes raros. Sin complicarte la vida.
          </p>

          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-4 gap-y-2 text-sm text-brand-purpleDark font-medium mt-2" data-id="element-101">
            <div className="flex items-center gap-1.5" data-id="element-102">
              <Check className="w-4 h-4 text-brand-purple" strokeWidth={3} data-id="element-103" />
              <span data-id="element-104">Acceso inmediato</span>
            </div>
            <span className="hidden sm:inline text-brand-purple/30" data-id="element-105">·</span>
            <div className="flex items-center gap-1.5" data-id="element-106">
              <Check className="w-4 h-4 text-brand-purple" strokeWidth={3} data-id="element-107" />
              <span data-id="element-108">Funciona con cualquier marca</span>
            </div>
            <span className="hidden sm:inline text-brand-purple/30" data-id="element-109">·</span>
            <div className="flex items-center gap-1.5" data-id="element-110">
              <Check className="w-4 h-4 text-brand-purple" strokeWidth={3} data-id="element-111" />
              <span data-id="element-112">Garantía de 5 días</span>
            </div>
          </div>

          <div className="mt-6 flex flex-col items-center md:items-start gap-3" data-id="element-113">
            <CtaButton text="→ Quiero mis recetas ahora" size="xl" className="w-full" data-id="element-114" />
            <p className="text-sm text-brand-mediumGray text-center md:text-left" data-id="element-115">
              Descarga instantánea en PDF — lo abrís desde el celu en segundos
            </p>
          </div>
        </div>

        <div className="relative mx-auto w-full max-w-md md:max-w-full order-1 md:order-2" data-id="element-116">
          <img src="https://cdn.magicpatterns.com/uploads/gvNRSBs7CPvvhShmiBmZAh/AC358B5D-8A9E-4683-8767-26B49CF693EA.png" alt="Recetas en Air Fryer" className="w-full h-auto drop-shadow-2xl" data-id="element-117" />
        </div>
      </div>
    </section>;
}